module.exports = __webpack_public_path__ + "img/icon_love_black.b8df33a4.png";